import { createContext, useContext } from "react";

const DisabledFormContext = createContext(false);

export const DisabledFormProvider = ({
  children,
  disabled: readOnly,
}: {
  children: React.ReactNode;
  disabled: boolean;
}) => {
  return (
    <DisabledFormContext.Provider value={readOnly}>
      {children}
    </DisabledFormContext.Provider>
  );
};

export const useIsFormDisabled = () => {
  return useContext(DisabledFormContext);
};
